import React from 'react'
import Font from '@cred/react-font'
import styles from './styles.module.scss'

const NoCards = () => (
  <div className={styles.noCards}>
    <div className={[styles.emptyCard, 'mb-24'].join(' ')} />
    <Font className={[styles.noCardsTitle, 'mb-24'].join(' ')} type="heading" weight="bold">
      We couldn’t find any results matching your criteria
    </Font>
    <Font className="mb-64 mb-lg-24">Try comparing cards with a different filter!</Font>
  </div>
)

export { NoCards }
export default NoCards
